import ReactDOM from "react-dom"
import React from "react"
import { App } from "@ui/app/App"
import { withRouter } from "@lib/router/router"
import { Routes } from "@lib/Routes"
import { initTelemetry } from "@lib/telemetry"

import "@static/styles/main.scss"

initTelemetry()

withRouter((router) => router.init(Routes))

ReactDOM.render(<App />, document.getElementById("root"))
